export default __webpack_public_path__ + "static/media/LogoSmall.220fed5b.svg";